import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";

const Search = () => {
  const [serieses, setSerieses] = useState([]);
  const [series, setSeries] = useState("");
  const [departments, setDepartments] = useState([]);
  const [department, setDepartment] = useState("");
  const [semesters, setSemesters] = useState([]);
  const [semester, setSemester] = useState("");
  const [subjects, setSubjects] = useState([]);
  const [subject, setSubject] = useState({});

  const history = useHistory();

  useEffect(() => {
    fetch("https://apichothaon1-hzrifat.b4a.run/serieses")
      .then((res) => res.json())
      .then((data) =>
        setSerieses(
          data?.map((d) => {
            return d?.name;
          })
        )
      );
  }, []);

  useEffect(() => {
    fetch("https://apichothaon1-hzrifat.b4a.run/depts")
      .then((res) => res.json())
      .then((data) =>
        setDepartments(
          data?.map((d) => {
            return d?.code;
          })
        )
      );
  }, []);

  useEffect(() => {
    fetch("https://apichothaon1-hzrifat.b4a.run/semesters")
      .then((res) => res.json())
      .then((data) =>
        setSemesters(
          data?.map((d) => {
            return d?.code;
          })
        )
      );
  }, []);

  useEffect(() => {
    department &&
      semester &&
      fetch(
        `https://apichothaon1-hzrifat.b4a.run/subjects/${department}${semester}`
      )
        .then((res) => res.json())
        .then((data) => setSubjects(data));
  }, [department, semester]);

  const directSearch = () => {
    history.push(
      `/collections/${series}/${department?.toLocaleLowerCase()}/${semester}/${subject?.code?.toLocaleLowerCase()}`
    );
  };

  return (
    <div style={{ position: "sticky", top: "30px", left: "0" }}>
      <div className="">
        <div
          style={{
            maxWidth: "500px",
            minWidth: "355px",
            background: "rgba(255, 255, 255, 0.5)",
            borderTop: "1px solid black",
            minHeight: "87vh",
          }}
          className="mt-2 mb-0 border rounded shadow-lg px-5 pt-5 pb-1"
        >
          <form
            onSubmit={directSearch}
            className="d-flex flex-column custom-form mt-4"
          >
            <h4 className="mb-5 text-center">Direct Search</h4>
            <div className="d-flex">
              <div className="w-50">
                <label className="mb-2" style={{ fontWeight: "500" }}>
                  Series <span className="text-danger">*</span>
                </label>
                <select
                  className="me-2"
                  required
                  onChange={(e) => setSeries(Number(e?.target?.value))}
                >
                  <option value="">Select</option>
                  {serieses?.map((s, i) => {
                    return (
                      <option key={i} value={s}>
                        {s}
                      </option>
                    );
                  })}
                </select>
              </div>
              <div className="w-50">
                <label className="ms-2 mb-2" style={{ fontWeight: "500" }}>
                  Department <span className="text-danger">*</span>
                </label>
                <select
                  className="ms-2"
                  required
                  onChange={(e) => setDepartment(e?.target?.value)}
                >
                  <option value="">Select</option>
                  {departments?.map((d, i) => {
                    return (
                      <option key={i} value={d}>
                        {d}
                      </option>
                    );
                  })}
                </select>
              </div>
            </div>

            <div className="d-flex">
              <div className="w-50">
                <label className="mb-2" style={{ fontWeight: "500" }}>
                  Semester <span className="text-danger">*</span>
                </label>
                <select
                  className="me-2"
                  required
                  onChange={(e) => setSemester(Number(e?.target?.value))}
                >
                  <option value="">Select</option>
                  {semesters?.map((s, i) => {
                    return (
                      <option key={i} value={s}>
                        {s?.toString()?.split("")?.join("-")}
                      </option>
                    );
                  })}
                </select>
              </div>
              <div className="w-50">
                <label className="ms-2 mb-2" style={{ fontWeight: "500" }}>
                  Subject <span className="text-danger">*</span>
                </label>
                <select
                  className="ms-2"
                  required
                  onChange={(e) =>
                    setSubject({ code: e?.target?.value, name: e?.target?.id })
                  }
                >
                  <option value="">Select</option>
                  {subjects?.map((s, i) => {
                    return (
                      <option
                        key={i}
                        id={s?.name}
                        value={`${s?.code}${s?.ext}`}
                      >{`${s?.code}${s?.ext} - ${s?.name}`}</option>
                    );
                  })}
                </select>
              </div>
            </div>

            <div className="mt-5 pt-5 mb-2">
              <input
                className="btn-custom mb-0"
                type="submit"
                value="Search!"
              />
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Search;
